import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NavBrand } from "@/components/navigation/NavBrand";
import { NavLinks } from "@/components/navigation/NavLinks";
import { api } from "@/lib/api";

export const AppNav = ({ user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      console.error("Logout request failed; clearing local navigation state.", error);
    }
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-[#E5E1D8] bg-[#F9F6F0]/85 backdrop-blur-xl" data-testid="app-navigation">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <NavBrand user={user} />

        <nav className="flex flex-wrap items-center gap-2" data-testid="nav-links-list">
          <NavLinks user={user} />
          <Button
            type="button"
            onClick={handleLogout}
            data-testid="nav-logout-button"
            className="rounded-full border border-[#E5E1D8] bg-white px-4 py-2 text-[#4A5D4E] shadow-none transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#C87961] hover:text-white"
          >
            <LogOut size={16} /> Logout
          </Button>
        </nav>
      </div>
    </header>
  );
};